import { useMutation } from '@apollo/client'
import { toast } from 'sonner'

import { ADD_TIVE_DEVICE_ID } from '../../data/mutations/tracking'
import { SHIPMENT_TRACKING_SOURCES } from '../../data/queries/tracking'
import { AddTrackingInput } from './add-tracking-input'

/**
 * This component is used to add a Tive device ID to a shipment.
 */
export const AddTiveDevice = ({ shipmentID }: { shipmentID: string }) => {
  const [addTiveDeviceID] = useMutation(ADD_TIVE_DEVICE_ID, {
    onCompleted: () => {
      toast.success('Tive device ID added successfully.')
    },
    onError: (error) => {
      toast.error(error.message || 'Something went wrong.')
    },
    refetchQueries: [SHIPMENT_TRACKING_SOURCES, 'TrackingSources']
  })

  return (
    <AddTrackingInput
      shipmentID={shipmentID}
      inputName="tiveDeviceID"
      buttonText="Add a Tive device ID"
      placeholder="Enter Tive device ID"
      mutation={addTiveDeviceID}
      validationPattern={/^[A-Za-z0-9-]+$/}
      validationMessage="Please enter a valid Tive device ID"
      successMessage="Tive device ID added successfully"
      errorMessage="Failed to add Tive device"
    />
  )
}
